var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDateString, IsEmail, IsNumber, IsObject, IsOptional, IsString, IsUUID, Matches, MaxLength, MinLength, } from 'class-validator';
import { countryRegex } from '../../countries.js';
import { PayedFeatureLiteDto, SubscriptionLiteDto } from '../../payment/index.js';
import { Role } from '../../roles/index.js';
import { UserProfileDto } from '../../user/dto/user.profile.dto.js';
/**
 * @deprecated Use {@link OfficeLocationResponseDto} from `@therame/shared` instead.
 */
export class OfficeLocationFullSizeDto {
    id;
    createdAt;
    updatedAt;
    deletedAt;
    office;
    calls;
    officeId;
    currentUsers;
    preventionCourseVouchers;
    name;
    abbreviation;
    ownerId;
    owner;
    allowedOfficeUsers;
    street;
    zip;
    town;
    countryCode;
    subdivisionCode;
    usesSeparateInvoiceAddress;
    companyNameForInvoice;
    streetForInvoice;
    zipForInvoice;
    townForInvoice;
    countryCodeForInvoice;
    profileImage;
    telephone;
    mondayFrom;
    mondayTo;
    mondayClosed;
    tuesdayFrom;
    tuesdayTo;
    tuesdayClosed;
    wednesdayFrom;
    wednesdayTo;
    wednesdayClosed;
    thursdayFrom;
    thursdayTo;
    thursdayClosed;
    fridayFrom;
    fridayTo;
    fridayClosed;
    saturdayFrom;
    saturdayTo;
    saturdayClosed;
    sundayFrom;
    sundayTo;
    sundayClosed;
    sloganLine1;
    sloganLine2;
    logoFile;
    registrationCode;
    officeRegistrationLinks;
    email;
    stripeCustomerId;
    payedFeatures;
    subscriptions;
    officeAchievement;
    officeLocationNews;
    invoices;
    isPinoTestOfficeLocation;
    officeLocationStats;
    connectedStripeAccountId;
    letterheadAssetId;
    /**
     * Calendar grid interval in minutes (divisor of 60). Drives the visible grid
     * lines and the default drag snap step in the week/day calendar views.
     */
    calendarInterval;
    connectedStripeAccount;
    officeLocationBranding;
    featureToggles;
}
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], OfficeLocationFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], OfficeLocationFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "deletedAt", void 0);
__decorate([
    IsObject(),
    Exclude(),
    __metadata("design:type", Function)
], OfficeLocationFullSizeDto.prototype, "office", void 0);
__decorate([
    IsArray(),
    Exclude(),
    __metadata("design:type", Array)
], OfficeLocationFullSizeDto.prototype, "calls", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationFullSizeDto.prototype, "officeId", void 0);
__decorate([
    IsArray(),
    Type(() => UserProfileDto),
    Exclude(),
    __metadata("design:type", Array)
], OfficeLocationFullSizeDto.prototype, "currentUsers", void 0);
__decorate([
    IsArray(),
    Exclude(),
    __metadata("design:type", Array)
], OfficeLocationFullSizeDto.prototype, "preventionCourseVouchers", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationFullSizeDto.prototype, "name", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationFullSizeDto.prototype, "abbreviation", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "ownerId", void 0);
__decorate([
    IsObject(),
    Type(() => UserProfileDto),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "owner", void 0);
__decorate([
    IsArray(),
    Type(() => UserProfileDto),
    Exclude(),
    __metadata("design:type", Array)
], OfficeLocationFullSizeDto.prototype, "allowedOfficeUsers", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationFullSizeDto.prototype, "street", void 0);
__decorate([
    IsString(),
    MinLength(4),
    MaxLength(5),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationFullSizeDto.prototype, "zip", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationFullSizeDto.prototype, "town", void 0);
__decorate([
    IsString(),
    MaxLength(3),
    Expose(),
    Matches(countryRegex),
    __metadata("design:type", String)
], OfficeLocationFullSizeDto.prototype, "countryCode", void 0);
__decorate([
    IsString(),
    IsOptional(),
    MaxLength(8),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "subdivisionCode", void 0);
__decorate([
    IsBoolean(),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.SUPERADMIN] }),
    __metadata("design:type", Boolean)
], OfficeLocationFullSizeDto.prototype, "usesSeparateInvoiceAddress", void 0);
__decorate([
    IsString(),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.SUPERADMIN] }),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "companyNameForInvoice", void 0);
__decorate([
    IsString(),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.SUPERADMIN] }),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "streetForInvoice", void 0);
__decorate([
    IsString(),
    MinLength(4),
    MaxLength(5),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.SUPERADMIN] }),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "zipForInvoice", void 0);
__decorate([
    IsString(),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.SUPERADMIN] }),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "townForInvoice", void 0);
__decorate([
    IsString(),
    MaxLength(3),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.SUPERADMIN] }),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "countryCodeForInvoice", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "profileImage", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "telephone", void 0);
__decorate([
    IsOptional(),
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "mondayFrom", void 0);
__decorate([
    IsOptional(),
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "mondayTo", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], OfficeLocationFullSizeDto.prototype, "mondayClosed", void 0);
__decorate([
    IsOptional(),
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "tuesdayFrom", void 0);
__decorate([
    IsOptional(),
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "tuesdayTo", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], OfficeLocationFullSizeDto.prototype, "tuesdayClosed", void 0);
__decorate([
    IsOptional(),
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "wednesdayFrom", void 0);
__decorate([
    IsOptional(),
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "wednesdayTo", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], OfficeLocationFullSizeDto.prototype, "wednesdayClosed", void 0);
__decorate([
    IsOptional(),
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "thursdayFrom", void 0);
__decorate([
    IsOptional(),
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "thursdayTo", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], OfficeLocationFullSizeDto.prototype, "thursdayClosed", void 0);
__decorate([
    IsOptional(),
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "fridayFrom", void 0);
__decorate([
    IsOptional(),
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "fridayTo", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], OfficeLocationFullSizeDto.prototype, "fridayClosed", void 0);
__decorate([
    IsOptional(),
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "saturdayFrom", void 0);
__decorate([
    IsOptional(),
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "saturdayTo", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], OfficeLocationFullSizeDto.prototype, "saturdayClosed", void 0);
__decorate([
    IsOptional(),
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "sundayFrom", void 0);
__decorate([
    IsOptional(),
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "sundayTo", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], OfficeLocationFullSizeDto.prototype, "sundayClosed", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(30),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "sloganLine1", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(30),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "sloganLine2", void 0);
__decorate([
    IsOptional(),
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "logoFile", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.SUPERADMIN] }),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "registrationCode", void 0);
__decorate([
    IsArray(),
    Expose(),
    __metadata("design:type", Array)
], OfficeLocationFullSizeDto.prototype, "officeRegistrationLinks", void 0);
__decorate([
    IsEmail(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "email", void 0);
__decorate([
    IsOptional(),
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "stripeCustomerId", void 0);
__decorate([
    IsArray(),
    Expose(),
    Type(() => PayedFeatureLiteDto),
    __metadata("design:type", Array)
], OfficeLocationFullSizeDto.prototype, "payedFeatures", void 0);
__decorate([
    IsArray(),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.SUPERADMIN] }),
    Type(() => SubscriptionLiteDto),
    __metadata("design:type", Array)
], OfficeLocationFullSizeDto.prototype, "subscriptions", void 0);
__decorate([
    IsObject(),
    Expose(),
    __metadata("design:type", Function)
], OfficeLocationFullSizeDto.prototype, "officeAchievement", void 0);
__decorate([
    IsObject(),
    Expose(),
    __metadata("design:type", Function)
], OfficeLocationFullSizeDto.prototype, "officeLocationNews", void 0);
__decorate([
    IsArray(),
    Exclude(),
    __metadata("design:type", Array)
], OfficeLocationFullSizeDto.prototype, "invoices", void 0);
__decorate([
    IsBoolean(),
    Expose({ groups: [Role.SUPERADMIN] }),
    __metadata("design:type", Boolean)
], OfficeLocationFullSizeDto.prototype, "isPinoTestOfficeLocation", void 0);
__decorate([
    IsObject(),
    Expose(),
    __metadata("design:type", Function)
], OfficeLocationFullSizeDto.prototype, "officeLocationStats", void 0);
__decorate([
    Exclude(),
    IsUUID(),
    IsOptional(),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "connectedStripeAccountId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationFullSizeDto.prototype, "letterheadAssetId", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Number)
], OfficeLocationFullSizeDto.prototype, "calendarInterval", void 0);
__decorate([
    IsObject(),
    Expose(),
    Exclude(),
    __metadata("design:type", Function)
], OfficeLocationFullSizeDto.prototype, "connectedStripeAccount", void 0);
__decorate([
    IsObject(),
    Expose(),
    __metadata("design:type", Function)
], OfficeLocationFullSizeDto.prototype, "officeLocationBranding", void 0);
__decorate([
    IsArray(),
    Expose(),
    __metadata("design:type", Array)
], OfficeLocationFullSizeDto.prototype, "featureToggles", void 0);
//# sourceMappingURL=office-location.full-size.dto.js.map